import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { WebsitePrimaryButton, TertiaryButton } from '@dev/ee-components';
import { CancelEditStep, getCheckoutCreatorStore, SaveStart } from '@/store/checkoutCreator/actions';
import { CheckoutCreatorStatus } from '@/store/checkoutCreator/types';
import { StepContentProps } from './types';
import { StepContentFooter, StepContentWrapper } from './styles';

export const StepContent = ({
    content,
    editContent,
    isEditMode,
    isNew,
    isSaveVisible,
    isSaveDisabled,
    onSave,
    wrapperRef
}: StepContentProps): JSX.Element => { 
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { status } = useSelector(getCheckoutCreatorStore);

    const onCancelEdit = (): void => {
        dispatch(CancelEditStep());
    };

    const onSaveEdit = (): void => {
        //for custom action on step save
        if(!!onSave){
            onSave();
            return;
        }
        dispatch(SaveStart({}));
    };

    const isSaving = status === CheckoutCreatorStatus.SAVING;
    const isContinueDisabled = isSaveDisabled || isSaving;

    if (isEditMode && isNew) {
        return(
            <StepContentWrapper ref={wrapperRef}>
                {editContent}
                {isSaveVisible && (
                        <StepContentFooter>
                            <WebsitePrimaryButton text={t('continue')} disabled={isContinueDisabled} onClick={onSaveEdit} isLoading={isSaving} />
                        </StepContentFooter>
                    )
                }
            </StepContentWrapper>
        );
    }
    
    if (isEditMode) {
        return(
            <StepContentWrapper ref={wrapperRef}>
                {editContent}
                <StepContentFooter>
                    <TertiaryButton onClick={onCancelEdit} text={t('cancel')} />
                    {isSaveVisible && <WebsitePrimaryButton text={t('save')} disabled={isContinueDisabled} onClick={onSaveEdit} isLoading={isSaving} />}
                </StepContentFooter>
            </StepContentWrapper>
        );
    }

    return(
        <StepContentWrapper ref={wrapperRef}>{content}</StepContentWrapper>
    );
};
